/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSurveyResult } from '../../models/get-survey-result';

export interface GetBySurveyid$Params {
  SurveyId: number;
  SurveyCampaignId: number;
}

export function getBySurveyid(
  http: HttpClient,
  rootUrl: string,
  params: GetBySurveyid$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetSurveyResult>> {
  const rb = new RequestBuilder(rootUrl, getBySurveyid.PATH, 'get');
  if (params) {
    rb.path('SurveyId', params.SurveyId, {});
    rb.query('SurveyCampaignId', params.SurveyCampaignId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSurveyResult>;
    }),
  );
}

getBySurveyid.PATH = '/Surveys/{SurveyId}';
